import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import store from './store'
import VueRouter from 'vue-router'
import VueLogger from 'vuejs-logger'; 
import HomeMain from './components/modules/home/HomeMain'
import LoginMain from './components/modules/login/LoginMain'
import DetailMain from './components/modules/detail/DetailMain'
import ReportMain from './components/modules/report/ReportMain'
import VueI18n from 'vue-i18n'
import VueCryptojs from 'vue-cryptojs'
import getBrowserLocale from "@/components/util/get-browser-locale"
import getCordovaWrapperVersion from "@/components/util/get-cordova-wrapper-version"
import VueGtag from "vue-gtag"
import discovery from "./discovery"

global.jQuery = require('jquery');
var $ = global.jQuery;
window.$ = $;

Vue.config.productionTip = false

//const debug = process.env.NODE_ENV !== 'production'
window.baseUrl = discovery.wedrive_main_url; 

// **********************************************************

Vue.use(VueCryptojs)

Vue.use(VueI18n)

function getStartingLocale() {
  const browserLocale = getBrowserLocale({ countryCodeOnly: true })
  const supportedLocales = ['es','en'];
  if (supportedLocales.includes(browserLocale)) {
    return browserLocale
  } else {
    return process.env.VUE_APP_I18N_LOCALE || "en"
  }
}

function loadLocaleMessages() {
  const locales = require.context(
    "./locales",
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  );
  const messages = {};
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });

  return messages;
}

export const i18n = new VueI18n({
  locale: getStartingLocale(),
  fallbackLocale: 'en',
  messages: loadLocaleMessages()
})

// **********************************************************

Vue.use(VueRouter)

const routes = [
  { path: '/', name: 'login', component: LoginMain },
  { path: '/home', name: 'home', component: HomeMain },
  { path: '/detail/:idFleet/:idMobile', name: 'detail', component: DetailMain },
  { path: '/report/:idFleet/:idMobile/:aliasMobile', name: 'report', component: ReportMain },
];

const router = new VueRouter({
  routes
})


Vue.use(VueGtag, {
  config: { id: discovery.wedrive_gtag_id}
}, router);


// **********************************************************
const isProduction = process.env.NODE_ENV === 'production';

const options = {
    isEnabled: true,
    logLevel : isProduction ? 'error' : 'debug',
    stringifyArguments : false,
    showLogLevel : true,
    showMethodName : true,
    separator: '|',
    showConsoleColors: true
};

Vue.use(VueLogger, options);


// **********************************************************
const vue =
    new Vue({
      vuetify,
      store,
      router,
      i18n,
      render: h => h(App)
    }).$mount('#app');

window.$vue = vue;

//FIXME: tiene que ser dinámico
window.$vue.$vuetify.lang.current = 'es';

window.$store = store;
window.$router = router;
window.$i18n = i18n;

/*********************************************/

window.$store.commit('wedrive/setCordovaWrapperVersion', getCordovaWrapperVersion());